import { createSvgIcon } from '@mui/material/utils';

export const DiscoverIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none">
    <mask id="path-1-inside-1_207_20614" fill="white">
      <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z" />
    </mask>
    <path
      d="M12 2V4C16.4183 4 20 7.58172 20 12H22H24C24 5.37258 18.6274 0 12 0V2ZM22 12H20C20 16.4183 16.4183 20 12 20V22V24C18.6274 24 24 18.6274 24 12H22ZM12 22V20C7.58172 20 4 16.4183 4 12H2H0C0 18.6274 5.37258 24 12 24V22ZM2 12H4C4 7.58172 7.58172 4 12 4V2V0C5.37258 0 0 5.37258 0 12H2Z"
      fill="currentColor"
      mask="url(#path-1-inside-1_207_20614)"
    />
    <path
      d="M16.4433 6.89478C16.8638 6.70399 17.2966 7.13655 17.1056 7.557L14.7419 12.756C14.3417 13.6363 13.6362 14.3419 12.7559 14.742L7.55755 17.105C7.13696 17.2962 6.70415 16.8634 6.89533 16.4428L9.25834 11.2445C9.65852 10.3641 10.364 9.65868 11.2443 9.25848L16.4433 6.89478ZM12.6288 11.3225C12.2383 10.9322 11.6051 10.9321 11.2146 11.3225C10.8244 11.7129 10.8244 12.3462 11.2146 12.7367C11.6051 13.1272 12.2383 13.127 12.6288 12.7367C13.0194 12.3462 13.0194 11.713 12.6288 11.3225Z"
      fill="currentColor"
    />
  </svg>,
  'Discover',
);
